import React from 'react';
import { Button } from '@avila-tek/ui/src';
import { CompanyStatusEnum } from '../../../models';
import { companyStatus } from '../../../static/companyStatus';

interface FormButtonProps {
  type: 'create' | 'update';
  toggleActive?: () => void;
  toggleStatus?: (status: CompanyStatusEnum) => void;
  active: boolean;
  disabled: boolean;
  status?: CompanyStatusEnum;
  onSubmit: (
    e:
      | React.FormEvent<HTMLFormElement>
      | React.MouseEvent<HTMLButtonElement, MouseEvent>
  ) => void;
}

function FormButtons({
  disabled,
  type,
  active,
  toggleActive,
  toggleStatus,
  onSubmit,
  status,
}: FormButtonProps) {
  return (
    <div className="flex self-end gap-[30px] mt-5 flex-wrap sm:flex-nowrap ">
      {status === companyStatus.pending || status === companyStatus.rejected ? (
        <Button
          type="button"
          className="bg-success-200"
          onClick={(e) => {
            e.preventDefault();
            toggleStatus(companyStatus.active);
          }}
        >
          Aceptar
        </Button>
      ) : null}
      {status === companyStatus.pending ? (
        <Button
          type="button"
          className={`bg-danger-200 `}
          onClick={(e) => {
            e.preventDefault();
            toggleStatus(companyStatus.rejected);
          }}
        >
          Rechazar
        </Button>
      ) : null}
      {!!toggleActive && type === 'update' ? (
        <Button
          type="button"
          className={`${!active ? 'bg-success-300' : 'bg-danger-300'}`}
          onClick={(e) => {
            e.preventDefault();
            toggleActive();
          }}
        >
          {active ? 'Desactivar' : 'Activar'}
        </Button>
      ) : null}
      <Button type="submit" onClick={onSubmit} disabled={disabled}>
        {type === 'update' ? 'Actualizar' : 'Crear'}
      </Button>
    </div>
  );
}

export default FormButtons;
